import { __assign } from "tslib";
import React from "react";
import { View } from "react-native";
import { PnmacHeadline, PnmacHtmlToNative } from "pnmac-universal-components";
import { textStyle } from "../../v2/theme";
function GetPayoffNotAvailable(_a) {
  var translations = _a.translations;
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHeadline, {
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      color: "#31afdf"
    })
  }, translations.GetPayoffRequestNotAvailable), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations === null || translations === void 0 ? void 0 : translations.GetPayoffRequestNotAvailable2
  }));
}
export default GetPayoffNotAvailable;